import script from "./ExamScoreTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamScoreTable.vue?vue&type=script&setup=true&lang=js"

import "./ExamScoreTable.vue?vue&type=style&index=0&id=2f0c2dbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0c2dbd"]])

export default __exports__